import { Box, Typography } from '@mui/joy';
import { LockSimple, LockSimpleOpen, PencilSimpleLine } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { IQuotePart } from 'quotes/types';
import { Color, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  onEditPartLineClick?: (quotePart: IQuotePart) => void;
  isRowEditable?: ({ data }) => boolean;
  isLockAllowed?: ({ data }) => boolean;
}

const LockCell = ({
  onEditPartLineClick,
  isRowEditable,
  isLockAllowed,
  setValue,
  ...props
}: IProps) => {
  const data = getAgGridTableCellData(props, QuotePartColId.LOCKED);
  if (!data) {
    const value = props?.value;

    if (value === undefined || value === null) {
      return null;
    }

    const Icon = value ? LockSimple : LockSimpleOpen;

    return <Icon weight={value ? 'fill' : null} />;
  }

  const groupedByColId = props?.node?.rowGroupColumn?.getColId();
  const isGroupedByLockCol = QuotePartColId.LOCKED === groupedByColId;

  const editable = isRowEditable && !isGroupedByLockCol ? isRowEditable({ data }) : false;

  const lockAllowed = isLockAllowed && !isGroupedByLockCol ? isLockAllowed({ data }) : false;

  const handleLockClick = () => {
    if (!lockAllowed) {
      return;
    }

    setValue(+!data?.locked);
  };

  const Icon = data?.locked ? LockSimple : LockSimpleOpen;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
      {editable && (
        <Typography
          color={Color.PRIMARY}
          level={Level.BODY_SM}
          onClick={onEditPartLineClick ? () => onEditPartLineClick(data) : undefined}
          sx={{ cursor: 'pointer' }}
        >
          <PencilSimpleLine />
        </Typography>
      )}

      <Icon
        weight={data?.locked ? 'fill' : null}
        style={{ cursor: lockAllowed ? 'pointer' : 'inherit' }}
        onClick={handleLockClick}
      />
    </Box>
  );
};

export default LockCell;
